// extracted by mini-css-extract-plugin
export default {"confirmButton":"ConfirmModal_confirmButton__i3Gtl"};